module.exports = __webpack_public_path__ + "static/media/ntuc-logo-nobg.2b68a9f8.png";